import locales from 'ck-locales';
import { deepClone } from './clone';
import MERGE_LABELS from '../data/sizeLabels';

/**
 * Sorting function for object that contains label property
 * @param a
 * @param b
 * @returns {number}
 */
export const sort = (a, b) => {
  const labelA = a.label.toUpperCase();
  const labelB = b.label.toUpperCase();
  if (labelA < labelB) {
    return -1;
  }
  if (labelA > labelB) {
    return 1;
  }
  return 0;
};

/**
 * Attempts to map string to locale, optionally falling back to normalised string (removing hashes)
 * @param {string} handle
 * @param {string} type = 'gender' | 'brand' | 'category' | 'subcategory' | 'icon';
 * @param {boolean} fallback
 * @returns {string}
 */
export const getLocaleString = (handle, type, fallback = true) => {
  const localeObject = locales.ck[type];
  if (!localeObject) {
    throw Error(`Cannot find target locale type ${type}`);
  }
  if (!handle) {
    return '';
  }
  const handleLowercase = String(handle).toLowerCase();
  return localeObject[handleLowercase] || (fallback ? handleLowercase.replace(/-/g, ' ') : '');
};

/**
 * Pushing string to array if not already exist
 */
const pushString = (array, string) => {
  const index = array.indexOf(string);
  if (index === -1) {
    array.push(string);
  }
};

/**
 * Merge items under one label. e.g. XXXXL to 4XL
 */
export const mergeItem = (items, item, targetLabel) => {
  const target = items.filter(x => x.label === targetLabel)[0];
  if (target) {
    target.count += item.count;
    target.isRefined = target.isRefined || item.isRefined;

    if (target.isRefined) {
      target.value = target.value.filter(x => targetLabel !== x && item.label !== x);
    } else {
      pushString(target.value, targetLabel);
      pushString(target.value, item.label);
    }
  } else {
    items.push(item);
  }
};

/**
 *  Reduce function used to normalise item labels and merge items
 */
export const normaliseSizeLabels = (items, item) => {
  item.originalLabel = item.label;
  const reduceGender = (genderItem) => {
    const ret = deepClone(genderItem);
    if (genderItem.label.indexOf('Men') >= 0 && item.label.indexOf('Women') >= 0) {
      ret.label = genderItem.label.replace('Men ', '').replace('Women ', '').replace(/ /g, '');

      // HACKY WAY TO REDUCE CHAMPION SLIP ON SIZES. TODO: fix this with different UX or data normalisation
      ret.label = ret.label.replace(/\/[+-]?\d+(\.\d+)?US/g, '');
    }
    return ret;
  };

  const mergeLabelItem = MERGE_LABELS.find(labelObj => (
    labelObj.target === item.label || labelObj.alts.indexOf(item.label) >= 0
  ));

  if (mergeLabelItem) {
    mergeItem(items, item, mergeLabelItem.target);
  } else {
    // custom handles
    items.push(reduceGender(item));
  }
  return items;
};

/**
 * Get the Icon code from the locale mapping
 * @param {string} category - name of the category or subCategory
 * @param {string} gender - "mens" | "womens" | "kids"
 * @returns {string} The icon code
 */
export const getIconCode = (category, gender) => {
  const handle = gender === 'mens' ? category : `${gender.replace('s', '')}-${category}`;
  const firstLookup = getLocaleString(handle, 'icon', false);
  if (firstLookup || handle === category) return firstLookup;
  // first look up may not return any icons if it is gender specific
  // Try get fallback icons using no genders
  return getLocaleString(category, 'icon', false);
};
